import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/globals.css";
import { App } from "./app/App";

async function bootstrap() {
  // Pure frontend: MSW is the only data source, always on.
  const { worker } = await import("./mocks/browser");
  await worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: { url: "/mockServiceWorker.js" },
    quiet: true,
  });

  // Prefetch as owner so role-gated handlers return data; restore real
  // session state afterwards so login flow still works.
  const { useRoleStore } = await import("./lib/stores/role");
  const persistedRole = useRoleStore.getState().currentRole;
  const persistedUserId = useRoleStore.getState().currentUserId;
  if (persistedRole === null) {
    useRoleStore.getState().loginAs("owner", "u_owner_001");
  }

  const { prefetchAll } = await import("./app/prefetch");
  await prefetchAll();

  if (persistedRole === null) {
    useRoleStore.getState().logout();
  } else {
    useRoleStore.getState().loginAs(persistedRole, persistedUserId ?? undefined);
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root not found");

  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
